export async function getFormattedDateTime() {
  const now = new Date();
  const pad = num => String(num).padStart(2, '0');

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1);      // Month is 0-based
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

export function formatUtcDateTimeToLocal(utcDateTime) {
  const hasTimeZone = /[zZ]|[+-]\d{2}:\d{2}$/.test(utcDateTime);
  const normalizedDateTime = hasTimeZone ? utcDateTime : `${utcDateTime}Z`;
  const formattedDateTime = new Date(normalizedDateTime).toLocaleString("sv-SE", {
    dateStyle: "short",
    timeStyle: "short"
  });
  return formattedDateTime;
}